import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  conversations: [],
};

export const conversationsSlice = createSlice({
  name: "metaData",
  initialState,
  reducers: {
    setConversations: (state, action) => {
      state = { ...state, conversations: action.payload };
      return state;
    },
  },
});

// Action creators are generated for each case reducer function
export const { setConversations } = conversationsSlice.actions;

export default conversationsSlice.reducer;
